module.exports = __webpack_public_path__ + "static/media/t.25427c7a.png";